import {
  PAYMENT_METHOD_DECLINED_CODE,
  PAYMENT_METHOD_DECLINED_MESSAGE,
  PAYMENT_METHOD_TOKEN_FIELD,
} from '@neon-one/auctions-types';

/**
 * Structural rather than `instanceof ApiError`: the surfaces already gate on
 * `err.code`, and a rejection that never reached the envelope parser has no
 * prototype to match.
 */
export function isPaymentMethodDeclined(err: unknown): boolean {
  if (typeof err !== 'object' || err === null) return false;
  return (err as { code?: unknown }).code === PAYMENT_METHOD_DECLINED_CODE;
}

/**
 * The reason to show the bidder. The decline arrives with the copy in two
 * places — the envelope message and a `paymentMethodToken` field entry — so
 * the field entry wins and the shared constant backstops both. All three are
 * cardholder-facing sentences; the issuer's reason code is never among them.
 */
export function paymentMethodDeclineMessage(err: unknown): string {
  if (typeof err !== 'object' || err === null) return PAYMENT_METHOD_DECLINED_MESSAGE;
  const { fieldErrors, message } = err as {
    fieldErrors?: Record<string, string[]>;
    message?: unknown;
  };
  const fromField = fieldErrors?.[PAYMENT_METHOD_TOKEN_FIELD]?.[0];
  if (fromField) return fromField;
  return typeof message === 'string' && message.trim() ? message : PAYMENT_METHOD_DECLINED_MESSAGE;
}
